export class LoginRequest {
  public username = '';
  public password = '';
}
